import { Component, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { HistoryData } from "../../providers/history";
import { Utilities } from "../../providers/utilities";
import * as sharedSelectors from "../../shared/reducers/shared.reducer";

@Component({
  selector: "app-history",
  templateUrl: "history.html",
})
export class HistoryComponent {

  @Input() public entity: string;

  public history$: Observable<{}>;
  public historyTmp$: Observable<{}>;
  public limit: number = 20;

  constructor(
    private historyData: HistoryData,
    private store: Store<{}>,
    private utilities: Utilities,
  ) { }

  public ngOnInit() {
    this.utilities.consoleDecorator("Entidad de busqueda historial", this.entity);

    this.store.select(sharedSelectors.getClient).subscribe((client: any) => {
      if (client) {
        this.historyTmp$ = this.historyData.get(this.entity).map((items) => {
          return items.sort((a: any, b: any) => b.timestamp - a.timestamp);
        });
        this.history$ = this.historyTmp$;
      }
    });
  }

  public searchHistory(ev: any) {
    this.history$ = this.historyTmp$.map((items: any) => items.filter((item) => this.utilities.searchItem(
      ev.target.value,
      item,
      ["action", "ip", "title", {user: ["email"]}],
    )));
  }

  public view(item) {
    this.utilities.Modal.create("HistoryViewPage", { object: item }).present();
  }

  public loadMore(infiniteScroll, list: any[]) {
    setTimeout(() => {
      if (this.limit < list.length) {
        this.limit += 20;
      }

      infiniteScroll.complete();
    }, 500);
  }

}



// WEBPACK FOOTER //
// ./src/components/history/history.ts